import { PropsWithChildren } from "react";
import styles from "./FilterValueSlot.module.css";

// A single full-width input slot (Month/Year picker), shared by Date filter's non-list modes.
const FilterValueSlot = ({ children }: PropsWithChildren) => <div className={styles.value}>{children}</div>;

export default FilterValueSlot;
